<template>
    <td class="actions" v-if="!!actions && !!actions.length">
        <div class="actions-wrap">
            <div class="dropdown" v-click-outside="closeDropdown">
                <btn
                    :action="toggleOpen"
                    :active="!!open"
                    type="primary"
                    table
                    label="Azioni"
                    :icon="['fad', 'ellipsis-v']"
                />
                <dropdown
                    v-if="!!openDropdown"
                    :items="normalizeChildrens()"
                    small
                ></dropdown>
            </div>
        </div>
    </td>
    <td v-else></td>
</template>

<script>
export default {
    data: () => ({
        open: false
    }),
    props: {
        actions: {
            type: Array,
            default: () => [],
            required: true
        },
        row: {
            type: Object,
            default: null,
            required: true
        },
        editRefmodal: {
            type: String,
            default: "",
            required: false
        },
        row_index: {
            type: Number,
            default: null,
            required: false
        },
        openModalWithData: {
            type: Function,
            default: null,
            required: true
        }
    },
    computed: {
        openDropdown: function() {
            return !!this.open && !!this.actions && !!this.actions.length;
        }
    },
    methods: {
        returnIcon: function(icon) {
            return Array.isArray(icon) ? icon : icon.split(" ");
        },
        getTargetByType: function(type) {
            switch (type.toUpperCase()) {
                case "VISIT":
                case "VIEW":
                case "EDIT":
                case "REPORT_SETTINGS":
                    return "_blank";
                    break;
                default:
                    return null;
            }
        },
        getIconByType: function(type) {
            switch (type.toUpperCase()) {
                case "VIEW":
                    return ["fad", "eye"];
                    break;
                case "VISIT":
                    return ["fad", "external-link"];
                    break;
                case "EDIT":
                case "EDIT_MODAL":
                case "EDIT_ROW":
                    return ["fad", "pencil"];
                    break;
                case "CREATE":
                case "DEARCHIVE":
                case "ADD":
                    return ["fad", "plus"];
                    break;
                case "DELETE":
                case "DELETE_PASSWORD":
                    return ["fad", "trash"];
                    break;
                case "CLONE":
                case "CLONE_REDIRECT":
                    return ["fad", "clone"];
                    break;
                case "ARCHIVE":
                    return ["fad", "archive"];
                    break;
                case "REMOVE":
                    return ["fad", "times"];
                    break;
                case "MAP":
                    return ["fad", "map-pin"];
                    break;
                case "LIST":
                    return ["fad", "list"];
                    break;
                case "UP":
                    return ["fad", "level-up-alt"];
                case "DOWN":
                    return ["fad", "level-down-alt"];
                case "EXCEL":
                    return ["fad", "file-excel"];
                    break;
                case "XML":
                    return ["fad", "file-code"];
                    break;
                case "TXT":
                    return ["fad", "file-alt"];
                    break;
                case "CSV":
                    return ["fad", "file-csv"];
                    break;
                case "PDF":
                    return ["fad", "file-pdf"];
                    break;
                case "REPORT_SETTINGS":
                    return ["fad", "cog"];
                    break;
                case "SEND":
                case "SEND_REPORT":
                    return ["fad", "paper-plane"];
                    break;
                case "READ":
                    return ["fad", "low-vision"];
                    break;
                case "MARKER":
                    return ["fad", "map"];
                    break;
                default:
                    return [];
            }
        },
        getTarget: function(item) {
            return this.getTargetByType(!!item.type ? item.type : "");
        },
        getIcon: function(item) {
            return this.getIconByType(!!item.type ? item.type : "");
        },
        getTitle: function(item) {
            return !!item.title ? item.title : "";
        },
        getMethod: function(item) {
            return !!item.method ? item.method.toUpperCase() : "GET";
        },
        isDestructive: function(item) {
            if (!!item.destructive) return true;
            else if (!item.type) return false;

            switch (item.type.toUpperCase()) {
                case "DELETE":
                case "REMOVE":
                case "DELETE_PASSWORD":
                    return true;
                    break;
                default:
                    return false;
            }
        },
        openModal: function(item) {
            if (!this.editRefmodal) return false;

            let data = {
                datas: this.row,
                urlupdate: item.link
            };

            this.$root.showModalWithData(this.editRefmodal, data);
        },
        editRow: function(item) {
            if (!this.editRefmodal) return false;

            let data = {
                datas: this.row,
                urlupdate: item.link
            };

            this.openModalWithData(data);
        },
        reqDel: function(link) {
            this.$root.requestDelete(this, link, function(data) {
                this.$emit("refreshTable");
            });
        },
        reqDelConfirm: function(link) {
            let value = prompt("Inserisci la tua Password");
            if (value != null && value != "") {
                this.$root.requestPost(
                    this,
                    link,
                    { password: value },
                    function(data) {
                        this.$emit("refreshTable");
                    }
                );
            }
        },
        reqPost: function(link) {
            this.$root.requestPost(this, link, {}, function(data) {
                this.$emit("refreshTable");
            });
        },
        reqPatch: function(link) {
            this.$root.requestPatch(this, link, {}, function(data) {
                this.$emit("refreshTable");
            });
        },
        reqPostRedirect: function(link) {
            this.$root.requestPost(this, link, {}, function(response) {
                if (response instanceof Object == false) return false;

                if (typeof response.data === "string")
                    window.location.href = response.data;
                else this.$emit("refreshTable");
            });
        },
        mapMoveToMarker: function(position) {
            this.$root.moveToMarker(position);
        },
        getAction: function(item) {
            if (!item.type || !item.link) return false;

            switch (item.type.toUpperCase()) {
                case "DELETE":
                case "REMOVE":
                    return this.reqDel.bind(this, item.link);
                    break;
                case "DELETE_PASSWORD":
                    return this.reqDelConfirm.bind(this, item.link);
                    break;
                case "ADD":
                    return this.reqPost.bind(this, item.link);
                    break;
                case "CLONE":
                    return this.reqPost.bind(this, item.link);
                    break;
                case "CLONE_REDIRECT":
                    return this.reqPostRedirect.bind(this, item.link);
                    break;
                case "EDIT_MODAL":
                    return this.openModal.bind(this, item);
                    break;
                case "EDIT_ROW":
                    return this.editRow.bind(this, item);
                    break;
                case "ARCHIVE":
                case "DEARCHIVE":
                    return this.reqPost.bind(this, item.link);
                    break;
                case "UP":
                case "DOWN":
                    return this.reqPost.bind(this, item.link);
                    break;
                case "SEND_REPORT":
                    return this.reqPost.bind(this, item.link);
                    break;
                case "READ":
                    return this.reqPatch.bind(this, item.link);
                    break;
                case "MARKER":
                    return this.mapMoveToMarker.bind(this, item.position);
                    break;
                default:
                    if (!!item.method)
                        this.$root.request(
                            this,
                            item.link,
                            item.method.toUpperCase(),
                            function(data) {
                                this.$emit("refreshTable");
                            }
                        );
                    return false;
            }
        },
        getFormMethod: function(item) {
            if (!item.type || !item.link) return false;

            switch (item.type.toUpperCase()) {
                case "DELETE_FORM":
                    return "DELETE";
                    break;
                case "CLONE_FORM":
                    return "POST";
                    break;
                default:
                    return false;
            }
        },
        normalizeChildrens: function() {
            let output = [];

            for (var i = 0; i < this.actions.length; i++) {
                let element = this.actions[i];

                output.push({
                    link: !!element.link ? element.link : "",
                    title: this.getTitle(element),
                    icon: this.getIcon(element),
                    separator: !!element.separator,
                    disabled: !!element.disabled,
                    destructive: this.isDestructive(element),
                    action: this.getAction(element),
                    formMethod: this.getFormMethod(element),
                    target: this.getTarget(element)
                });
            }

            return output;
        },
        closeDropdown: function() {
            if (!!this.open) this.open = false;
        },
        toggleOpen: function() {
            if (!!this.link) return;

            this.open = !!this.open ? false : true;
        }
    }
};
</script>
